var _a;
export var RSS_ROUTE_TYPES = {
    BLOG: 'BLOG',
};
export var RSS_ROUTES = (_a = {},
    _a[RSS_ROUTE_TYPES.BLOG] = 'blog-feed.xml',
    _a);
export var BLOG_TPA_PAGE_ID = 'blog';
export var WIX_DATA_PAGE_URL = 'wix-data-page-item.page-url';
export var STATIC_PAGE_URL = 'page.url';
